module.exports = __webpack_public_path__ + "img/58.3323439d.png";